import moment from 'moment-timezone';
import React, { FC, useState } from 'react';
import {
  MonitoringDateRange,
  calculateStep,
  calculateUnit,
  getDefaultMonitoringDateRange,
} from '../../monitoring/DateRange-Dropdown-util';

import { FlexGroup, FlexItem } from '@lithos';
import { TimeSelector } from '@tecton';

import { useSearchParams } from 'react-router-dom';
import { ServerGroupStatus } from '../../../types/tecton_proto/common/server_group_status';
import { useUserSettings } from '../../context/UserSettingsContext';
import FeatureServerGroup from './FeatureServerGroup';
import RealtimeMonitoringWorkspaceSelector from './RealtimeMonitoringWorkspaceSelector';
import { CalloutVariant } from '@lithos/Callout';

export type ServerGroupStatusType = Record<ServerGroupStatus, { title: string; status: CalloutVariant }>;

const RealtimeServerMonitoring: FC = () => {
  const { workspace } = useUserSettings();

  const [selectedWorkspace, setSelectedWorkspace] = useState<string>(workspace ?? 'prod');

  return <RealtimeService selectedWorkspace={selectedWorkspace} setSelectedWorkspace={setSelectedWorkspace} />;
};

const RealtimeService: FC<{
  selectedWorkspace: string;
  setSelectedWorkspace: React.Dispatch<React.SetStateAction<string>>;
}> = ({ selectedWorkspace, setSelectedWorkspace }) => {
  // Date Selector states
  const defaultMonitoringDateRange: MonitoringDateRange = getDefaultMonitoringDateRange();
  const [monitoringDateRange, setMonitoringDateRange] = useState<MonitoringDateRange>(defaultMonitoringDateRange);

  const [searchParams, setSearchParams] = useSearchParams();

  const onWorkspaceSelected = (workspace?: string) => {
    setSelectedWorkspace(workspace ?? '');
  };

  return (
    <FlexGroup direction="column" css={{ height: '100%', overflow: 'hidden' }} padding="0">
      <FlexItem grow={0} shrink={0}>
        <FlexGroup>
          <TimeSelector
            onSelection={(start, end) => {
              const step = calculateStep(moment(start), moment(end));
              const unit = calculateUnit(moment(start), moment(end));
              setMonitoringDateRange({
                startTime: () => start.valueOf(),
                endTime: () => end.valueOf(),
                requestId: `${start.valueOf()}${end.valueOf()}`,
                step,
                unit,
              });
            }}
          />
          <RealtimeMonitoringWorkspaceSelector
            onWorkspaceSelected={onWorkspaceSelected}
            selectedWorkspace={selectedWorkspace}
          />
        </FlexGroup>
      </FlexItem>

      <FlexItem grow={1} shrink={0} css={{ height: '100%', overflow: 'scroll' }}>
        <FeatureServerGroup monitoringDateRange={monitoringDateRange} selectedWorkspace={selectedWorkspace} />
      </FlexItem>
    </FlexGroup>
  );
};

export default RealtimeServerMonitoring;
